export default __webpack_public_path__ + "static/media/star.09866642.svg";